module.exports = __webpack_public_path__ + "img/logo-alt.30a023f8.webp";